var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8764 11.3173C16.4142 6.85516 9.17956 6.85516 4.71737 11.3173C4.27803 11.7567 3.56572 11.7567 3.12638 11.3173C2.68704 10.878 2.68704 10.1657 3.12638 9.72635C8.46725 4.38549 17.1265 4.38549 22.4674 9.72635C22.9067 10.1657 22.9067 10.878 22.4674 11.3173C22.028 11.7567 21.3157 11.7567 20.8764 11.3173ZM15.592 16.7146C14.0054 15.2878 11.5883 15.2878 10.0017 16.7146C9.53975 17.13 8.82844 17.0923 8.41299 16.6303C7.99753 16.1683 8.03526 15.457 8.49725 15.0415C10.9393 12.8455 14.6544 12.8455 17.0965 15.0415C17.5585 15.457 17.5962 16.1683 17.1807 16.6303C16.7653 17.0923 16.054 17.13 15.592 16.7146Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4207 18.5925C11.4207 17.8331 12.0363 17.2175 12.7957 17.2175C13.5551 17.2175 14.1708 17.8331 14.1708 18.5925C14.1708 19.3519 13.5552 19.9675 12.7958 19.9675C12.0364 19.9675 11.4207 19.3519 11.4207 18.5925Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27596 14.0985C10.3242 11.0502 15.2665 11.0502 18.3148 14.0985C18.7541 14.5378 19.4664 14.5378 19.9058 14.0985C20.3451 13.6592 20.3451 12.9468 19.9058 12.5075C15.9788 8.58055 9.61194 8.58055 5.68497 12.5075C5.24563 12.9469 5.24563 13.6592 5.68497 14.0985C6.12431 14.5378 6.83662 14.5378 7.27596 14.0985Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoWifi);
export default __webpack_public_path__ + "static/media/DuoWifi.8f0232033d3ef995dd8b8324485b77ed.svg";
export { ForwardRef as ReactComponent };